module.exports = __webpack_public_path__ + "static/media/step6.2924e490.png";


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfCommon/Pay3/images/sber/step6.png
// module id = 709
// module chunks = 0